var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#036;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m401.05,59.06h0c-10.34-10.34-27.11-10.34-37.45,0l-104.01,104.01,39.53-62.74s5.56-8.46,6.26-9.72c.23-.42.45-.84.66-1.27.2-.32.35-.65.46-.99,4.21-9.69,2.37-21.38-5.55-29.3h0c-10.34-10.34-27.11-10.34-37.45,0l-104.8,104.8,40.02-63.52s5.6-7.98,6.58-9.74c5.57-10.07,4.08-22.99-4.46-31.53h0c-10.34-10.34-27.11-10.34-37.45,0L30.95,191.49c-10.34,10.34-10.34,27.11,0,37.45h0c10.34,10.34,27.11,10.34,37.45,0l104.84-104.84-38.88,61.71s-6.55,9.5-7.48,11.11c-.66,1.13-1.22,2.29-1.7,3.49-.17.33-.3.67-.39,1.03-3.26,9.31-1.18,20.07,6.26,27.51h0c10.34,10.34,27.11,10.34,37.45,0l105.63-105.63-39.38,62.5s-6.65,9.17-7.78,11.11c-5.89,10.13-4.5,23.34,4.18,32.02h0c10.34,10.34,27.11,10.34,37.45,0l132.44-132.44c10.34-10.34,10.34-27.11,0-37.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.5f852885410b66b411bbe56ec909575f.svg";
export { ForwardRef as ReactComponent };